import styled from "@emotion/styled";
import { CircularProgress } from "@mui/material";

const Wrapper = styled.div`
  position: fixed;
  display: flex;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.white};
`;

const Loader = styled(CircularProgress)`
  width: 177px !important;
  height: 177px !important;
`;

export { Wrapper, Loader };
